export const enum TrackingEventType {
  /**
   * Zainicjowano umawianie wizyty
   */
  SCHEDULE_INITIATED,

  /**
   * Umówiono wizytę
   */
  SCHEDULED,

  /**
   * Zmieniono stronę
   */
  NAVIGATION_CHANGED,

  /**
   * Wyszukano posty na blogu
   */
  BLOG_SEARCHED
}

export interface TrackingEvent {
  readonly type: TrackingEventType;
  readonly data?: { [key: string]: any }
}

export function scheduleInitiated(): TrackingEvent {
  return {
    type: TrackingEventType.SCHEDULE_INITIATED
  };
}

export function scheduled(): TrackingEvent {
  return {
    type: TrackingEventType.SCHEDULED
  };
}

export function navigationChanged(from: string, to: string): NavigationChangedEvent {
  return {
    type: TrackingEventType.NAVIGATION_CHANGED,
    data: {
      from,
      to
    }
  };
}

export function blogSearched(query: string, categories: string[]): BlogSearchedEvent {
  return {
    type: TrackingEventType.BLOG_SEARCHED,
    data: {
      query,
      categories
    }
  };
}

interface NavigationChangedEvent extends TrackingEvent {
  readonly type: TrackingEventType.NAVIGATION_CHANGED;
  readonly data: {
    readonly from: string;
    readonly to: string;
  }
}

interface BlogSearchedEvent extends TrackingEvent {
  readonly type: TrackingEventType.BLOG_SEARCHED;
  readonly data: {
    readonly query: string;
    readonly categories: string[];
  }
}
